import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
	shareCss: {
		zIndex: 999,
		position: 'relative',
		textAlign: 'start',
		cursor: 'pointer',

		height: '23px',
		width: '21px',
		'& > * svg': {
			color: '#FFFFFF',
			height: '23px',
			width: '21px',
		},
	},
	likeIconStyle: {
		position: 'relative',
		zIndex: 999,
		textAlign: 'end',
		cursor: 'pointer',
		height: '23px ',
		width: '27px !important',

		'& > * svg': {
			color: '#FFFFFF',
			height: '23px',
			width: '25px important',
		},
	},
	hoverStyle: {
		fill: 'none',
		stroke: '#002855',
	},
	hoverStyle2: {
		fill: 'none',
		stroke: '#fff',
		'&:hover': {
			stroke: '#14A0D6 !important',
		},
	},
}));

export default useStyles;
